"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagedRegistrationSchema = void 0;
exports.ManagedRegistrationSchema = {
    type: 'object',
    required: ['form_ids', 'thank_you_page_id'],
    additionalProperties: false,
    properties: {
        form_ids: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'string',
            },
        },
        page_ids: {
            type: 'array',
            items: {
                type: 'string',
            },
        },
        email_campaign_id: {
            type: [
                'string',
                'null',
            ],
        },
        thank_you_page_id: {
            type: [
                'string',
                'null',
            ],
        },
        decline_workflow_id: {
            type: [
                'string',
                'null',
            ],
        },
        stage_name: {
            type: 'string',
        },
        registration_pending_stage_name: {
            type: 'string',
        },
        registration_completed_stage_name: {
            type: 'string',
        },
        next_workflow_ids: {
            type: 'object',
            properties: {
                new_contact: {
                    type: [
                        'string',
                        'null',
                    ],
                },
                invited_contact: {
                    type: [
                        'string',
                        'null',
                    ],
                },
                existing_contact: {
                    type: [
                        'string',
                        'null',
                    ],
                },
            },
        },
    },
};
